/**
 * Metric names
 */
export const INITIALIZE_WIDGET_FAILURE = 'InitializeWidgetFailure';
export const INITIALIZE_WIDGET_REQUEST = 'InitializeWidgetRequest';
export const PAGE_LOAD_SUCCESS = 'PageLoadSuccess';
export const EXISTING_WIDGET_PRESENT = 'ExistingWidgetPresent';

export const INITIALIZE_ANSFOOTER = 'InitializeAnsFooter';
export const ANSFOOTER_INITIALIZATION_FAILURE = 'AnsFooterInitializationFailure';

/**
 * Method names
 */
export const LOAD_WIDGET = 'LoadWidget';
export const LOAD_WIDGET_IFRAME = 'LoadWidgetIframe';

/**
 * Cloudwatch Metric specifications
 */
export const METRIC_NAMESPACE = "AnsFooterAssets-PageLevelMetrics";
export const METRIC_UNIT_COUNT = "Count";
export const URL_PATH_DIMENSION = "urlPath";
export const WIDGET_TYPE_DIMENSION = "widgetType";
